import React from "react";
import { motion } from "framer-motion";
import { Card, CardContent } from "../ui/Card";
import { Check, Clock, Star } from "lucide-react";
const OverviewSection = ({service}) => {
  return (
    <div className="row gy-4">
      <motion.div
        className="col-lg-4"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Card className="h-100 shadow-sm rounded-4">
          <CardContent>
            <h4>Key Features</h4>
            <ul className="list-unstyled mt-3">
              {service.features.map((feat, idx) => (
                <li key={idx} className="d-flex align-items-start mb-2">
                  <Check size={18} className="me-2 text-primary" />
                  <span>{feat}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </motion.div>
      <motion.div
        className="col-lg-4"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Card className="h-100 shadow-sm rounded-4 card-gradient-purple">
          <CardContent>
            <h4>Benefits</h4>
            <ul className="list-unstyled mt-3">
              {service.benefits.map((ben, idx) => (
                <li key={idx} className="d-flex align-items-start mb-2">
                  <Star size={18} className="me-2 text-purple" />
                  <span>{ben.title || ben}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </motion.div>
      <motion.div
        className="col-lg-4"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Card className="h-100 shadow-sm rounded-4 card-gradient-green">
          <CardContent>
            <h4>Our Process</h4>
            <ol className="list-unstyled mt-3">
              {service.process.map((stepObj, idx) => (
                <li key={idx} className="mb-3">
                  <div className="d-flex align-items-center mb-2">
                    <span className="badge bg-success rounded-circle me-2 step-number">
                      {idx + 1}
                    </span>
                    <strong>{stepObj.step || stepObj}</strong>
                  </div>
                  <p className="mb-1">{stepObj.description || ""}</p>
                  {stepObj.duration && (
                    <small className="text-muted d-flex align-items-center">
                      <Clock size={14} className="me-1" /> Duration:{" "}
                      {stepObj.duration}
                    </small>
                  )}
                </li>
              ))}
            </ol>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
};

export default OverviewSection;
